import { FSA } from 'flux-standard-action';
import {
  BOOKABLE_BUSY_FETCH_REQUESTED,
  BOOKABLE_BUSY_FETCH_SUCCEEDED,
  BOOKABLE_BUSY_FETCH_FAILED,
} from './action-types';

const initialState = {
  status: '',
  data: {},
};

export default function reducer(state = initialState, action: FSA<any, any>) {
  switch (action.type) {
    case BOOKABLE_BUSY_FETCH_REQUESTED:
      return { ...state, status: 'loading' };
    case BOOKABLE_BUSY_FETCH_SUCCEEDED:
      return {
        ...state,
        status: 'done',
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    case BOOKABLE_BUSY_FETCH_FAILED:
      return { ...state, status: 'failed' };
    default:
      return state;
  }
}
